import { getUserStore } from "~/solidJs/entities/HeaderMain/models";
import { NodeVisibility } from "~/solidJs/shared/helpers/types/INodeDefinition";
import { TaskApi } from "../network/TaskApi";

export class CustomElementDefinition {
	isVisible = NodeVisibility.Visible;
	constructor(category, globalId, name, description, coverPictureUrl, tags, onCreationCallback) {
		this.category = category;
		this.globalId = globalId;
		this.name = name;
		this.description = description;
		this.coverPictureUrl = coverPictureUrl;
		this.tags = tags;
		this.onCreationCallback = onCreationCallback;
	}
}
/**
 * data layer that configure node
 */
export class NodeDefinition {
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToSvg = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToGenPrompt = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToOutPaint = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToZoomOut = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToVariate = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToAutoMask = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToPromptEnhance = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToDescribeImage = false;
	/**
 @type {string}
 configures hover flag
 */
	isNeedToMjVariate = false;
	/**
 @type {string}
 configures hover flag
 */
	isNeedToMjUpscale = false;
	/**
 @type {string}
 configures hover flag
 */
	isNeedToMjZoomOut = false;
	/**
 @type {string}
 configures hover flag
 */
	isNeedToMjPan = false;
	/**
 @type {boolean}
 configures socket order
 */
	isNeedToRevertSocketOrder = false;
	/**
	
 @type {boolean}
 configures hover flag
 */
	isNeedToVariationsPro = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToPromptVariations = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToReimagine = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToRecolor = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToRestyle = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToCrop = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToVision = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToRandomModels = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedDalleGenerate = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToDetailedUpscale = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToUpscale = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToFaceRestore = false;
	/**
 @type {boolean}
 configures hover flag
 */
	isNeedToDownscale = false;
	createTaskImpl = TaskApi.postStartTraining.bind(TaskApi);
	getTaskStatusImpl = TaskApi.getTaskStatus.bind(TaskApi);
	/**
	 * used for local nodes eg cropper for synch result with server
	 */
	isNeedToSynchOutputs = false;
	/**
	 * used to disable outputs sync for some particular nodes
	 */
	isNeedToCopyOutputs = true;
	/**
	 * @type {IUserTemplateParams}
	 */
	userTemplateParams;
	/**
	 * @type {SocketDefinition[]}
	 */
	params;
	/**
	 * @type {SocketDefinition[]}
	 */
	inputs;
	/**
	 * @type {SocketDefinition[]}
	 */
	outputs;
	/**
	 * medianTime in seconds
	 * @type {number}
	 */
	medianTime = 0;
	/**
	 * flag from airtable used to hide node from sidebar
	 * @type {NodeVisibility}
	 */
	isVisible = NodeVisibility.Visible;
	/**
	 * flag that determines is node available to user
	 * @type {boolean}
	 */
	isAvailable = true;
	/**
	 * flag from manages showability of styles widget
	 * @type {boolean}
	 */
	isStylesShowable = false;

	/**
	 * flag that manages is node needs to fetch user models from backend
	 * @type {boolean}
	 */
	isNeedToFetchModels = false;

	/**
	 * flag that manages is node needs to fetch user loras from backend
	 * @type {boolean}
	 */
	isNeedToFetchLoras = false;

	/**
	 * flag that indicates if node requires English-only input
	 * @type {boolean}
	 */
	isEnglishOnly = false;

	/**
	 * tag string to serach for
	 * @type {string}
	 */
	serachTags = "";

	/**
	 * flag that controlls is modification of parametrs is enabled on node adding
	 */
	isModificationEnabled = true;
	/**
	 * default price of node in credits
	 */
	defaultPrice = 0;
	/**
	 * @type {(props?: {x:number; y: number}) => void}
	 */
	onCreationCallback;
	constructor(
		category,
		globalId,
		name,
		description,
		averageTimeInSeconds,
		inputs,
		params,
		outputs,
		initExecutionGroup,
		useOutputViewer = true,
		coverPictureUrl = null,
		tags = null,
		neuralNetworks = null,
		serviceId = 0,
		multiSocket = false,
		multiViewer = false,
		isNeedToInitViewer = false,
		copiedOutputs = null,
		isNeedToAddClearBtn = false,
		isNeedToCopyOutputs = true,
		serviceVersion = "0.0.0",
		isVisible = NodeVisibility.Visible,
		isAvailable = true,
		createTaskImpl = TaskApi.postStartTraining.bind(TaskApi),
		getTaskStatusImpl = TaskApi.getTaskStatus.bind(TaskApi),
		defaultPrice = 0
	) {
		this.isNeedToCopyOutputs = isNeedToCopyOutputs;
		this.isNeedToAddClearBtn = isNeedToAddClearBtn;
		this.serviceId = serviceId;
		this.category = category;
		this.globalId = globalId;
		this.name = name;
		this.description = description;
		this.averageTimeInSeconds = averageTimeInSeconds;
		this.inputs = inputs;
		this.params = params;
		this.outputs = outputs;
		this.copiedOutputs = copiedOutputs;
		this.initExecutionGroup = initExecutionGroup;
		this.initalExecutionGroupFC = initExecutionGroup;
		this.useOutputViewer = useOutputViewer;

		this.coverPictureUrl = coverPictureUrl;
		this.tags = tags;
		this.neuralNetworks = neuralNetworks;
		this.isNeedToInitViewer = isNeedToInitViewer;

		this.multiSocket = multiSocket;
		this.multiViewer = multiViewer;
		this.serviceVersion = serviceVersion;
		this.isVisible = isVisible;
		this.isAvailable = isAvailable;
		this.createTaskImpl = createTaskImpl;
		this.getTaskStatusImpl = getTaskStatusImpl;
		this.defaultPrice = defaultPrice;
	}

	/**
	 *
	 * @returns is this node need to fetch models from the server
	 */
	isFetchesExternalModels() {
		return this.isNeedToFetchLoras || this.isNeedToFetchModels;
	}

	/**
	 * Merges socket data with data from airtable
	 * @deprecated for new merge functionality use  {@link import("~/js/network/mergeMlBase").mergeMlBase} and {@link modifyMlDefinition}
	 */
	setSocketsDisplay(socketsDisplay) {
		if (!socketsDisplay) return;
		const handleSocketGroup = (socketDefinitionsGroup, socketDisplayGroup) => {
			for (const socketDefinition of socketDefinitionsGroup) {
				const socketDisplayData = socketDisplayGroup[socketDefinition.name];
				if (!socketDisplayData) continue;

				if (socketDisplayData.name) socketDefinition.setDisplayName(socketDisplayData.name);

				if (socketDisplayData.limits)
					socketDefinition.optionalInfo.valueOptions = {
						...socketDefinition.optionalInfo.valueOptions,
						limits: { ...socketDisplayData.limits }
					};
				if (socketDisplayData.validateSimilar)
					socketDefinition.optionalInfo.valueOptions = {
						...socketDefinition.optionalInfo.valueOptions,
						validateSimilar: socketDisplayData.validateSimilar
					};
				if (socketDisplayData.toggleGroup) {
					socketDefinition.optionalInfo.toggleGroup = socketDisplayData.toggleGroup;
				}
				if (socketDisplayData.globalCheckedModifiers) {
					socketDefinition.optionalInfo.globalCheckedModifiers =
						socketDisplayData.globalCheckedModifiers;
				}
				if (socketDisplayData.isNeedToMoveFromSettings) {
					socketDefinition.optionalInfo.isNeedToMoveFromSettings =
						socketDisplayData.isNeedToMoveFromSettings;
				}
				if (socketDisplayData.isNeedToMoveToSettings) {
					socketDefinition.optionalInfo.isNeedToMoveToSettings =
						socketDisplayData.isNeedToMoveToSettings;
				}
				if (socketDisplayData.globalUnCheckedModifiers) {
					socketDefinition.optionalInfo.globalUnCheckedModifiers =
						socketDisplayData.globalUnCheckedModifiers;
				}
				if (socketDisplayData.intLimitsAccessGroup) {
					socketDefinition.optionalInfo.intLimitsAccessGroup =
						socketDisplayData.intLimitsAccessGroup;
				}
				if (socketDisplayData.hasAccessGroupMap) {
					socketDefinition.optionalInfo.accessDisabled = !(
						getUserStore()?.group in socketDisplayData.hasAccessGroupMap
					);
				}
				if (socketDisplayData.isNeedToFetchModels) {
					socketDefinition.optionalInfo.isNeedToFetchModels = true;
					socketDefinition.optionalInfo.model_type = socketDisplayData.model_type;
					socketDefinition.optionalInfo.valueOptions = {
						values: [
							{
								name: "---",
								value: "",
								modifiers: {
									inputs: {
										mask: {
											isEnabled: true
										}
									}
								}
							}
						]
					};
				}
				if (socketDisplayData.dataType) {
					socketDefinition.dataType = socketDisplayData.dataType;
				}
				socketDefinition.optionalInfo.isExpaned = socketDisplayData?.isExpaned;

				if (socketDisplayData.description)
					socketDefinition.optionalInfo.description = socketDisplayData.description;
				socketDefinition.optionalInfo.group = socketDisplayData.group;
				socketDefinition.optionalInfo.isNeedToHideName = socketDisplayData.isNeedToHideName;
				socketDefinition.optionalInfo.isNeedToHelp = socketDisplayData.isNeedToHelp;
			}
		};
		if (socketsDisplay.outputs) {
			handleSocketGroup(this.outputs, socketsDisplay.outputs);
		}
		if (socketsDisplay.inputs) {
			handleSocketGroup(this.inputs, socketsDisplay.inputs);
		}
		if (socketsDisplay.params) {
			handleSocketGroup(this.params, socketsDisplay.params);
		}
	}
}

export class SocketDefinition {
	/**
	 * @type {any}
	 */
	value;
	/**
	 * @type {import("~/solidJs/shared/helpers/types/INodeDefinition").IDataType}
	 */
	dataType;

	/**
	 * @param {string} name     Displayed name of socket.
	 * @param {string} dataType Data type of socket.
	 * @param {any}    value    Default value of socket.
	 * @param {null|boolean}  optional soket is optional
	 * @param {Object} options  Custom options for value. (It can be undefined)
	 */
	constructor(name, dataType, optionalInfo = {}, optional = null, displayName = null) {
		this.name = name;
		this.dataType = dataType;
		this.optionalInfo = {
			...optionalInfo
		};
		this.optional = optional;
		this.displayName = displayName;
	}

	setDisplayName(displayName) {
		if (displayName) this.displayName = displayName;
	}

	getName() {
		return this.displayName ? this.displayName : this.name;
	}

	getPlaceholder() {
		return this.optionalInfo.placeholder ? this.optionalInfo.placeholder : this.getName();
	}

	getDescription() {
		return this.optionalInfo.description ? this.optionalInfo.description : this.getName();
	}
}
